import styled from 'styled-components';
import device from '@deprecated-ui/_style/device';
import Image from 'global/Image';
import { AboutContainerInner } from '../styled';

export const VisionContainer = styled(AboutContainerInner)`
  flex-direction: column-reverse;
  margin-top: 32px;

  @media ${device.tablet} {
    flex-direction: row;
  }
`;

export const VisionMissionBox = styled.section`
  @media ${device.tablet} {
    width: calc(100% - 250px);
    display: flex;
    width: 100%;
    align-items: center;
    padding: 16px 80px 16px 16px;
    border: 1px solid #ededed;
    border-radius: 12px;
  }

  @media ${device.laptop} {
    width: 100%;
  }
`;

export const VisMisBox = styled.section`
  @media ${device.mobileS} {
    h3 {
      text-align: center;
    }
  }

  @media ${device.tablet} {
    flex: 1;

    h3 {
      text-align: left;
    }
  }

  ul {
    padding-left: 30px;
    padding-top: 16px;
  }
`;

export const VisionImage = styled(Image)`
  width: 200px;
  margin-bottom: 40px;

  @media ${device.tablet} {
    width: 250px;
    margin-bottom: 0;
  }

  @media ${device.laptop} {
    width: auto;
  }
`;

export const VisionImageContainer = styled.section`
  @media ${device.mobileS} {
    display: flex;
    justify-content: center;
  }

  @media ${device.tablet} {
    display: block;
  }
`;
